module.exports = __webpack_public_path__ + "img/icon-03.5f9a7368.png";